import React, {Component, createRef} from 'react';
// CSS
import './Students.scss';

// Helper
import {checkCookie} from '../../Helper/Cookies';
import { apiFetch, getCurrentUser } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Confirm } from '../../components/UI/Overlays';
import { EmptyState, TableWait, Chip, StatTile, UserCell, Tip } from '../../components/UI/Feedback';
import { Toolbar } from '../../components/UI/Controls';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

// Properties
const properties = require('../../properties.json');

class AllStudents extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        globalFilter: null,

        // Teacher Identifier
        branchID: getCurrentUser()?.branchId,

        // Data
        data: [],

        // Update Data
        resend: false ,
        visible : false ,

        // ---- the page's own states: the wait and the question both have a
        // shape now ----
        tableLoading: true,

        // ids resolved to the names the teacher knows
        materialsById: {},

        // the request the teacher asked to remove, held while the card is up
        doomed: null,
        deleting: false,

        // which request is being activated right now
        confirming: null,
    }

    getStudents = () => {
        this.setState({ tableLoading: true });
        apiFetch("/students/period-orders", { query: { branchId: this.state.branchID } })
        .then(fetchStudents => {
            this.setState({
                data: fetchStudents,
                tableLoading: false
            });
        })
        .catch(error => {
            this.setState({ tableLoading: false });
            console.error("Error:", error);
        });
    }

    // A row carries the id of the material it belongs to; this turns it into
    // the name the teacher knows it by. Same shape as the lessons page.
    getMaterials = () => {
        const user = getCurrentUser();
        apiFetch("/lookup/materials", { query: { branchId: user?.branchId, teacherUserId: user?.userId } })
        .then(materials => {
            const materialsById = {};
            materials.forEach(m => { materialsById[m.id] = m.name; });
            this.setState({ materialsById });
        })
        .catch(error => console.error("Error:", error));
    }

    viewStudent =(R)=>{


    }

    // The question is asked in the product's own card now; everything after
    // "yes" is the call it always was.
    deleteStudent = (periodOrderId) => {
        var _this = this;

        this.setState({ deleting: true });

        apiFetch(`/students/period-orders/${periodOrderId}`, { method: "DELETE" })
        .then(() => {
            this.setState({resend: true, doomed: null, deleting: false});
            _this.toast.current.show({severity: 'success', summary: 'تمت العملية', detail: 'تم الحذف بنجاح'});
        })
        .catch(error => {
            console.error('Error:', error)
            this.setState({doomed: null, deleting: false});
            _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: 'خطأ في الإتصال'});
        });
    }

    editStudent = (periodOrderId) => {
        var _this = this;

        this.setState({ confirming: periodOrderId });

        apiFetch(`/students/period-orders/${periodOrderId}/confirm`, { method: "POST" })
        .then(() => {
            this.setState({resend: true, confirming: null});
            _this.toast.current.show({severity: 'success', summary: 'تمت العملية', detail: 'تم الاشتراك بنجاح'});
        })
        .catch(error => {
            console.error('Error:', error)
            this.setState({ confirming: null });
            _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: 'خطأ في الإتصال'});
        });
    }
    componentDidMount () {
        document.title = properties.site_name + " | كل الطلاب";

       // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
        }

        this.getStudents();
        this.getMaterials();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.resend !== this.state.resend) {
            this.getStudents();

            this.setState({resend: false});
        }
    }

        render() {
        const { data, tableLoading, doomed, deleting, confirming } = this.state;

        // what is waiting, and what it is worth, before a single row is read
        const money = data.reduce((sum, r) => sum + Number(r.value || 0), 0);
        const periodsAsked = new Set(data.map(r => r.periodName).filter(Boolean)).size;

        const actionBodyTemplate = (rowData) => {
            return (
                <React.Fragment>
                    <Tip text="امتحانات الطالب">
                        <Button icon="pi pi-eye" className="p-button-rounded p-button-secondary p-ml-2" onClick={() => window.location.href = `exams/view/${rowData.id}`} />
                    </Tip>

                    <Tip text="فعّل الاشتراك">
                        <Button
                            icon={confirming === rowData.id ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            className="p-button-rounded p-button-success p-ml-2"
                            disabled={confirming === rowData.id}
                            onClick={() =>
                              this.editStudent(rowData.id)
                            }
                        />
                    </Tip>

                    <Tip text="ارفض الطلب">
                        <Button
                            icon="pi pi-trash"
                            className="p-button-rounded p-button-danger"
                            onClick={() => this.setState({ doomed: rowData })}
                        />
                    </Tip>
                </React.Fragment>
            );
        }

        // the student as the teacher knows them: their name, with the number
        // they are reached on underneath
        const nameBody = (row) => (
            <UserCell name={row.studentFullName} sub={row.studentMobile || "من غير رقم"} />
        );

        // what the request is for: the period, with its material under it
        const placeBody = (row) => (
            <span className="ui-stack">
                <b>{row.periodName || "—"}</b>
                <small>{this.state.materialsById[row.materialId] || "—"}</small>
            </span>
        );

        const moneyBody = (row) =>
            row.value === null || row.value === undefined || row.value === "" ? (
                <Chip kind="off">من غير مبلغ</Chip>
            ) : (
                <span className="ui-money">
                    <b>{Number(row.value).toLocaleString("en-US")}</b>
                    <small>ج.م</small>
                </span>
            );

        // whatever the student wrote with the request, kept quiet but kept
        const remarkBody = (row) => {
            const note = String(row.remark || "").trim();
            if (!note) return <span className="ui-bits is-none">—</span>;
            return <span className="ui-note" title={note}>{note}</span>;
        };

        return (
            <>
                <Header pageName="تفعيل الطلاب" />

                <Toast ref={this.toast}></Toast>

                <Confirm
                    visible={!!doomed}
                    onHide={() => this.setState({ doomed: null })}
                    name={doomed ? doomed.studentFullName : ""}
                    note={
                        doomed
                            ? `طلب الاشتراك في «${doomed.periodName || "—"}» هيترفض ويتشال من القائمة، والطالب هيحتاج يطلب تاني.`
                            : ""
                    }
                    confirmLabel="أيوه، ارفض الطلب"
                    busyLabel="بنرفض الطلب…"
                    busy={deleting}
                    onConfirm={() => this.deleteStudent(doomed.id)}
                />

                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card>
                                {/* a queue, measured before it is worked through */}
                                <div className="ui-tiles">
                                    <StatTile
                                        brand
                                        icon="pi pi-user-plus"
                                        label="طلبات منتظرة التفعيل"
                                        value={tableLoading ? "…" : data.length}
                                    />
                                    <StatTile
                                        icon="pi pi-calendar"
                                        tone="teal"
                                        label="فترات مطلوبة"
                                        value={tableLoading ? "…" : periodsAsked}
                                    />
                                    <StatTile
                                        icon="pi pi-wallet"
                                        tone="gold"
                                        label="قيمة الطلبات"
                                        value={tableLoading ? "…" : `${money.toLocaleString("en-US")} ج.م`}
                                    />
                                </div>

                                <Toolbar
                                    value={this.state.globalFilter || ""}
                                    onSearch={(v) => this.setState({ globalFilter: v })}
                                    placeholder="بحث باسم الطالب أو رقمه"
                                    count={tableLoading ? null : `${data.length} طلب`}
                                />

                                <DataTable sortable globalFilter={this.state.globalFilter}
                                className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                                value={data} paginator rows={10} rowsPerPageOptions={[10,20,50]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                emptyMessage={
                                    tableLoading ? (
                                        <TableWait />
                                    ) : (
                                        <EmptyState
                                            title="مفيش طلبات تفعيل"
                                            hint="لما طالب يطلب الاشتراك في فترة، الطلب هيستناك هنا تفعّله أو ترفضه"
                                            icon="pi pi-user-plus"
                                            secondary={{ label: "شوف طلابي", url: "/myStudents" }}
                                        />
                                    )
                                }>
                                    <Column sortable field="studentFullName" header="الطالب" body={nameBody}></Column>
                                    <Column sortable field="studentMobile" header="رقم التلفون" style={{ width: "160px" }}></Column>
                                    <Column sortable field="periodName" header="الفترة والمادة" body={placeBody} style={{ width: "200px" }}></Column>
                                    <Column sortable field="value" header="القيمة" body={moneyBody} style={{ width: "140px" }}></Column>
                                    <Column header="ملاحظة الطالب" body={remarkBody}></Column>
                                    <Column header="عرض / تفعيل / رفض" body={actionBodyTemplate}></Column>

                                </DataTable>
                            </Card>
                        </div>
                    </div>

                </div>
            </>
        );
    }
}

export default AllStudents;
